import { render, staticRenderFns } from "./ElementYearResultTableColumn.vue?vue&type=template&id=60ab2792&scoped=true"
import script from "./ElementYearResultTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementYearResultTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementYearResultTableColumn.vue?vue&type=style&index=0&id=60ab2792&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ab2792",
  null
  
)

export default component.exports